import { Injectable,Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { catchError,map } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import * as globalConstant from './../global_constant';
import {WINDOW} from '../global_constant';


@Injectable({
  providedIn: 'root'
})
export class ReferralCodeService {
	_window = Inject(WINDOW);

  apiDomain	   	    		=	globalConstant.DOMAIN;
  siteRequestFrom			=	globalConstant.SITE_REQUEST_FROM;
  saveReferralSourceApi		=	globalConstant.SAVE_REFERRAL_SOURCE_API;
  influencerReferralLogSourceApi		=	globalConstant.INFLUENCER_VISITOR_LOG;
  private authUserSubject = new BehaviorSubject<any>(null);
  authUser$ = this.authUserSubject.asObservable();

  
  constructor(public router: Router,private http: HttpClient) {  

  } 

  setAuthUser(user: any) {
    localStorage.setItem('authUser', JSON.stringify(user));
    this.authUserSubject.next(user);
  }

  getAuthUser() {
    return JSON.parse(localStorage.getItem('authUser'));
  }

  influencerReferralLog(formData){
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'requestFrom':this.siteRequestFrom
        })
      };
      return this.http.post<any>(this.apiDomain+this.influencerReferralLogSourceApi,formData,httpOptions).pipe(map(res=>{
        return res;
      }),
      catchError(err => {
       if(err.status == 401)
        {
          if(typeof localStorage !== 'undefined'){
            localStorage.removeItem('authUser')
            localStorage.removeItem('login_token')
            localStorage.removeItem('profile_img_url')
          }
          if (typeof this._window !== 'undefined') {
            this._window.location.href = '/login'
          }
        } 
        return err.error;
      }));
    }

  saveReferralSource(formData){
      const httpOptions = {
          headers: new HttpHeaders({
            //'Vebo-Key': 'sdfsf456s1df21sfs89f7sfsfs23f12s3f4s',
            'Content-Type': 'application/json',
            //'Authorization':'Bearer '+headers,
			'requestFrom':this.siteRequestFrom
          })
        };
        return this.http.post<any>(this.apiDomain+this.saveReferralSourceApi,formData,httpOptions).pipe(map(res=>{
          return res;
        }),
        catchError(err => {
         if(err.status == 401)
          {
            if(typeof localStorage !== 'undefined'){
              localStorage.removeItem('authUser')
              localStorage.removeItem('login_token')
              localStorage.removeItem('profile_img_url')
            }
            if (typeof this._window !== 'undefined') {
              this._window.location.href = '/login'
            }
          } 
          return err.error;
        }));
      }
	 
}




